const changeStatusInputManagementEquip = {
  title: 'INACTIVATE EQUIPMENTS',
  title2: 'REACTIVATE EQUIPMENTS',
};

export default changeStatusInputManagementEquip;
